export const MAP_BASE_PATH = '/karte'

export const baseUrl = (url: string) =>
  cleanUrl(`${process.env.NEXT_PUBLIC_SHOP_URL}${url.startsWith('/') ? '' : '/'}${url}`)

const cleanUrl = (input: string) => {
  const url = new URL(input)
  // Remove duplicate slashes in the pathname
  url.pathname = url.pathname.replace(/\/{2,}/g, '/')

  return url.toString()
}
